import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppClientComponentModule, AppClientResourcesModule, ApplicationClientCommonModule, CommonLayoutModule, CommonTranslationModule, CommonUIModule,  ServiceResponseModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TmcYardCommonModule } from '../../common/common.module';
import { RegisterEntranceLeaveComponent } from './component/register-entrance-leave.component';
import { GateComponent } from './component/entrance-gate/gate.component';
import { HintsComponent } from './component/hints/hints.component';
import { WeighingComponent } from './component/entrance-weighing/weighing.component';
import { SupplementaryEquipmentComponent } from './component/supplementary-equipment/supplementary-equipment.component';
import { TransportDetailsModule } from '../../common/components/transport-details/transport-details.module';
import { TasksComponent } from './component/tasks/tasks.component';
import { SupplementaryEquipmentItemComponent } from './component/supplementary-equipment/supplementary-equipment-item.component';
import { TaskItemComponent } from './component/tasks/task-item.component';
import { PictureSeriesTaskDialogComponent } from './component/tasks/picture-series-task-dialog.component';
import { TaskProcessingHintDialogComponent } from './component/tasks/task-processing-hint.dialog.component';
import { OuthandedSupplementaryEquipmentItemComponent } from './component/supplementary-equipment/outhanded-supplementary-equipment-item.component';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    RegisterEntranceLeaveComponent,
    GateComponent,
    HintsComponent,
    WeighingComponent,
    SupplementaryEquipmentComponent,
    SupplementaryEquipmentItemComponent,
    OuthandedSupplementaryEquipmentItemComponent,
    TasksComponent,
    TaskItemComponent,
    PictureSeriesTaskDialogComponent,
    TaskProcessingHintDialogComponent
  ],
  exports: [
    RegisterEntranceLeaveComponent
  ],
  imports: [
    CommonModule,

    CommonLayoutModule,
    CommonUIModule,
    CommonLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    AppClientComponentModule,
    AppClientResourcesModule
  ]
})
export class RegisterEntranceLeaveModule { }
